import { 
    GET_ACCESSORY,
    GET_ALL_ACCESSORIES,
    GET_ACCESSORY_REQUEST,
    CREATE_ACCESSORY,
    UPDATE_ACCESSORY,
    DELETE_ACCESSORY,
    CLEAR_ACCESSORY
} from '../actions/types';

const initialState = {
    accessories: [],
    accessory: null,
    assetPath: null,
    loading: true
}

export default (state = initialState, { type, payload }) => {
    switch (type) {

    case CREATE_ACCESSORY:
        return { 
            ...state, 
            accessories: [payload, ...state.accessories],
            accessory: payload.accessory,
            assetPath: payload.assetPath,
            loading: false 
        };

    case GET_ALL_ACCESSORIES:
        return { 
            ...state, 
            accessories: payload,
            loading: false 
        };

    case GET_ACCESSORY:
        return { 
            ...state, 
            accessory: payload.accessory,
            assetPath: payload.assetPath,
            loading: false 
        };

    case GET_ACCESSORY_REQUEST:
        return { 
            ...state, 
            loading: payload 
        };

    case UPDATE_ACCESSORY:
        return {
            ...state,
            accessories: state.accessories.map(accessory => 
                accessory._id === payload._id ? payload : accessory
            ),
            accessory: payload.accessory,
            assetPath: payload.assetPath,
            loading: false
        };

    case DELETE_ACCESSORY:
        return {
            ...state,
            accessories: state.accessories.filter(accessory => accessory._id !== payload),
            loading: false
        };

    case CLEAR_ACCESSORY:
        return {
            ...state,
            accessory: null,
            loading: false
        };

    default:
        return state
    }
} 